import { makeStyles, createStyles } from '@material-ui/core/styles';

import { variables } from '@styles';

/**
 * UniversalContainer component styles
 * @returns {Function}
 */

export const useStyles = makeStyles((theme) =>
  createStyles({
    universalContainer: {
      backgroundColor: 'transparent',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',

      '&[data-ui-type=primary]': {
        '& $item': {
          // minWidth: '12.7rem',
          width: `calc((100% - ${theme.spacing(4)}px) / 3)`,
          margin: theme.spacing(0, 1.5, 2, 0),

          '&:nth-child(3n)': {
            marginRight: 0,
          },

          ['@media (min-width: 1024px) and (max-width: 1650px)']: {
            marginRight: 0,
            width: '100%',

            '& > div > .MuiButton-outlinedPrimary': {
              width: '100%',
            },

            '&:nth-child(4)': {
              width: '114px',
              minWidth: 'auto',
            },

            '&:nth-child(5)': {
              width: '110px',
              minWidth: 'auto',
              marginRight: '0',
            },
          },
        },

        '& $itemSecond': {
          margin: '0 1.2rem 0 0',
          minWidth: '12.7rem',
          width: `calc((100% - ${theme.spacing(3)}px) / 2)`,

          '&:last-child': {
            marginRight: 0,
          },

          '& input': {
            height: '3rem',
          },

          ['@media (min-width: 1024px) and (max-width: 1650px)']: {
            minWidth: 'auto',
          },
        },

        '& $caption': {
          marginBottom: theme.spacing(1),
        },

        '& $section': {
          display: 'flex',
          flexWrap: 'wrap',
        },
      },
    },
    titleWrapper: {
      flex: '0 0 auto',
      padding: '0 1.6rem 2rem 1.6rem',
    },
    title: {
      alignItems: 'center',
      color: `${variables.colorV2.text.header}`,
      display: 'flex',
      fontSize: '2rem',
      fontWeight: 400,
      justifyContent: 'space-between',
      lineHeight: '2.5rem',
      // paddingBottom: '1rem',
    },

    contentContainer: {
      background: variables.colorV2.panel.background.default,
      borderRadius: '2rem',
      flex: '0 1 auto',
      overflowY: 'hidden',
      padding: '2rem 1.6rem',

      '& .MuiAccordion-root': {
        '&:not(:last-child)': {
          paddingBottom: '2rem',
        },
      },
    },

    settingsContainer: {
      height: '100%',
      overflowY: 'auto',
    },

    section: {},
    item: {},
    itemSecond: {},

    count: {
      '&&': {
        padding: theme.spacing(1),
        width: '4.5rem',

        '& p': {
          color: variables.color.primary.darkestGray,
        },
      },
    },

    countButton: {
      width: '3rem',
      padding: theme.spacing(1),
      color: variables.color.primary.mediumGray,
      borderColor: variables.color.primary.lightGrayDarker,
      fontSize: variables.font.size.xxl,

      '&.Mui-disabled': {
        backgroundColor: variables.color.primary.lightGrayDarker,
        borderColor: variables.color.primary.lightGrayDarker,
        color: variables.color.primary.mediumGray,
      },

      '&:hover': {
        borderColor: variables.colorV2.button.contained.secondary.border.hover,
        color: variables.colorV2.button.contained.secondary.border.hover,
        backgroundColor: 'transparent',
      },
    },

    toggleButton: {
      '&&': {
        width: '3.2rem',
        height: '3.2rem',
        padding: theme.spacing(0.75),
        borderRadius: variables.borderRadius.sm,
        marginRight: theme.spacing(1),
        border: `${variables.borderWidth.md} solid ${variables.color.primary.lightGrayDarker}`,
        transition: 'all 0.3s',

        '&:last-child': {
          marginRight: 0,
        },

        '&.Mui-selected': {
          backgroundColor: variables.colorV2.button.contained.secondary.background.active,
          borderColor: variables.colorV2.button.contained.secondary.border.active,

          '& svg path': {
            fill: variables.color.primary.white,
          },

          '& svg line': {
            stroke: variables.color.primary.white,
          },

          '&:hover': {
            backgroundColor: variables.colorV2.button.contained.secondary.background.hover,
            borderColor: variables.colorV2.button.contained.secondary.border.hover,

            '& svg path': {
              fill: variables.color.primary.white,
            },

            '& svg line': {
              stroke: variables.color.primary.white,
            },
          },
        },

        '&:hover': {
          borderColor: variables.colorV2.button.contained.secondary.border.hover,
          backgroundColor: 'transparent',

          '& svg path': {
            fill: variables.colorV2.button.contained.secondary.border.hover,
          },

          '& svg line': {
            stroke: variables.colorV2.button.contained.secondary.border.hover,
          },
        },
      },
    },

    caption: {},

    linkSettings: {
      display: 'flex',
      flexDirection: 'column',

      '& $itemSecond': {
        width: '100% !important',

        '&:last-child': {
          marginTop: '2rem',
        },
      },
    },

    editModeContainer: {
      padding: '2rem 1.6rem 2rem 1.6rem',
    },

    buttonContainer: {
      display: 'flex',
      justifyContent: 'flex-start',
      // minWidth: '60rem',
      // width: '60rem',
    },

    save: {
      // marginLeft: 'auto',
      '&:disabled': {
        // backgroundColor: variables.color.primary.backgroundLighterGray,
        // border: `0.1rem solid ${variables.color.primary.lightGrayDarker}`,
        // color: variables.color.primary.lightGrayDarker,
      },
    },

    close: {
      '&&': {
        borderRadius: '3.2rem',
        fontWeight: 500,
        marginRight: '.8rem',
        // border: `1px solid ${variables.colorV2.button.contained.secondary.border.default}`,
        // color: variables.colorV2.button.contained.secondary.text.default,

        '&:hover': {
          // backgroundColor: variables.colorV2.button.contained.secondary.background.hover,
          // border: `1px solid ${variables.colorV2.button.contained.secondary.border.hover}`,
          // color: variables.colorV2.button.contained.secondary.text.hover,
        },
      },
    },
  }),
);
